export default __webpack_public_path__ + "static/4i-17e7244f4b78c6b2c7e149cc43ea6384.woff";